import React, { useEffect, useState } from "react";
import { getAllTenders } from "../services/tenderService";
import TenderCard from "../components/common/TenderCard";
import PageHeader from '../components/PageHeader';

const Tender = () => {
  const [tenders, setTenders] = useState([]);
  const [filteredTenders, setFilteredTenders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const tendersPerPage = 5;

  useEffect(() => {
    const fetchTenders = async () => {
      const data = await getAllTenders();
      console.log("Tenders from API:", data);
      setTenders(data);
      setFilteredTenders(data);
    };

    fetchTenders();
  }, []);

    const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Pages', link: '/pages' },
    { label: 'Notice Board', active: true },
  ];


  const indexOfLastTender = currentPage * tendersPerPage;
  const indexOfFirstTender = indexOfLastTender - tendersPerPage;
  const currentTenders = filteredTenders.slice(indexOfFirstTender, indexOfLastTender);

  const totalPages = Math.ceil(filteredTenders.length / tendersPerPage);

  return (
<>
  <PageHeader title="Notice Board/ Tender" breadcrumbs={breadcrumbs} />

    <div className="container mt-5">
     
      {/* Tender List */}
      {currentTenders.map((tender) => (
        <TenderCard key={tender.id} tender={tender} />
      ))}

      {/* Pagination */}
      <div className="d-flex justify-content-center mt-4">
        <nav>
          <ul className="pagination">
            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>

    </>
  );
};

export default Tender;
